import { makeFichaAvisoURL } from '@navent-jobs/interlinking'
import { SiteConfig } from '@navent-jobs/config'
import { BASE_URL, SITE_ID } from '.'
import { PromedioSalarial } from '../redux/types/promedioSalarial'

interface DataInterface {
  '@context': string
  '@type': string
  itemListElement: {
    '@type': string
    position: number
    name: string
    url: string
  }[]
}

export const listadoAvisosItemList = avisos => {
  const data: DataInterface = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [],
  }

  if (avisos) {
    avisos.forEach((aviso, index) => {
      const infoAviso = {
        '@type': 'ListItem',
        position: index + 1,
        name: aviso.titulo,
        url: `${BASE_URL}${makeFichaAvisoURL({
          id: aviso.id,
          titulo: aviso.titulo,
          empresa: { denominacion: aviso.empresa, confidencial: aviso.confidencial },
        })}`,
      }
      data.itemListElement.push(infoAviso)
    })
  }

  return JSON.stringify(data)
}

/**
 * Crea los datos estructurados para el promedio salarial de una subarea
 */
export const listadoAvisosOccupationSalary = (promedioSalarialSubarea: PromedioSalarial, currencyCode: string) => {
  const data = {
    '@context': 'https://schema.org/',
    '@type': 'Occupation',
    name: promedioSalarialSubarea?.nombre,
    mainEntityOfPage: {
      '@type': 'WebPage',
      lastReviewed: promedioSalarialSubarea?.fechaModificacion,
    },
    estimatedSalary: [
      {
        '@type': 'MonetaryAmountDistribution',
        name: 'base',
        currency: currencyCode,
        duration: 'P1M',
        minValue: promedioSalarialSubarea?.minimo?.toString(),
        maxValue: promedioSalarialSubarea?.maximo?.toString(),
        median: promedioSalarialSubarea?.promedio?.toString(),
      },
    ],
    occupationLocation: [
      {
        '@type': 'Country',
        name: SiteConfig[SITE_ID].pais.nombre,
      },
    ],
  }
  return JSON.stringify(data)
}
